import { ISearchAndDiscovery } from '../../interfaces/searchAndDiscovery/iSearchAndDiscovery'
import { INonprofit } from "../../interfaces/searchAndDiscovery/iNonprofit";
import { ICause } from "../../interfaces/iCause";
import { IKeyName } from "../../interfaces/IKeyName";
import { IMetropolitanArea } from "../../interfaces/iMetropolitanArea";

export class SearchAndDiscovery implements ISearchAndDiscovery {
    selectedMemberMetropolitanAreas: IMetropolitanArea[];
    selectedRemotefriedly: IKeyName[];
    selectedOppenOpportunities: IKeyName[];
    selectedEventTypes: IKeyName[];
    selectedPrefTypes: IKeyName[];
    template: string = "";
    selectedCauses: ICause[] = [];
    totalNonprofitsByQuery: number = 0;
    nextPage: number;
    queryNumber: number = 0;
    nonprofits: INonprofit[] = [];
    keywords: string[] = [];
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/searchAndDiscovery/searchAndDiscovery.ts